import { render, staticRenderFns } from "./NotificationInline.vue?vue&type=template&id=afd62344&scoped=true&"
import script from "./NotificationInline.vue?vue&type=script&lang=js&"
export * from "./NotificationInline.vue?vue&type=script&lang=js&"
import style0 from "./NotificationInline.vue?vue&type=style&index=0&id=afd62344&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd62344",
  null
  
)

export default component.exports